import { render, staticRenderFns } from "./WebsiteTrain.vue?vue&type=template&id=653a6267&scoped=true"
import script from "./WebsiteTrain.vue?vue&type=script&lang=js"
export * from "./WebsiteTrain.vue?vue&type=script&lang=js"
import style0 from "./WebsiteTrain.vue?vue&type=style&index=0&id=653a6267&prod&lang=scss"
import style1 from "./WebsiteTrain.vue?vue&type=style&index=1&id=653a6267&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653a6267",
  null
  
)

export default component.exports